import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import register from '@/components/register'
import success from '@/components/success'
import login from '@/components/login'
import loginSelect from '@/components/loginSelect'
import choose from '@/components/choose'
import info from '@/components/info'
import edit from '@/components/edit'
import error from '@/components/error'
import indexlist from '@/components/indexlist'
import storelist from '@/components/storelist'
import storedetail from '@/components/storedetail'
import pdfView from '@/components/pdfView'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/index/:id',
      name: 'index',
      component: index
    },
    {
      path: '/loginSelect/:id',
      name: 'loginSelect',
      component: loginSelect
    },
    {
      path: '/login/:id',
      name: 'login',
      component: login
    },
    {
      path: '/choose/:id',
      name: 'choose',
      component: choose
    },
    {
      path: '/register/:id',
      name: 'register',
      component: register
    },
    {
      path: '/info',
      name: 'info',
      component: info
    },
    {
      path: '/edit',
      name: 'edit',
      component: edit
    },
    {
      path: '/success',
      name: 'success',
      component: success
    },
    {
      path: '/error',
      name: 'error',
      component: error
    },
    {
      path: '/indexlist',
      name: 'indexlist',
      component: indexlist
    },
    {
      path: '/storelist/:id',
      name: 'storelist',
      component: storelist
    },
    {
      path: '/storedetail/:id/:activeId',
      name: 'storedetail',
      component: storedetail
    },
    {
      path: '/pdfView',
      name: 'pdfView',
      component: pdfView
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
  next()
});

export default router

// const router = new Router({
//   routes: [
//     {
//       path: '/index/:id',
//       name: 'index',
//       component: index
//     },
//     {
//       path: '/loginSelect/:id',
//       name: 'loginSelect',
//       component: loginSelect
//     },
//     {
//       path: '/login/:id',
//       name: 'login',
//       component: login
//     },
//     {
//       path: '/choose/:id',
//       name: 'choose',
//       component: choose
//     },
//     {
//       path: '/register/:id',
//       name: 'register',
//       component: register
//     },
//     {
//       path: '/info',
//       name: 'info',
//       component: info
//     },
//     {
//       path: '/edit',
//       name: 'edit',
//       component: edit
//     },
//     {
//       path: '/success',
//       name: 'success',
//       component: success
//     },
//     {
//       path: '/error',
//       name: 'error',
//       component: error
//     },
//     {
//       path: '/indexlist',
//       name: 'indexlist',
//       component: indexlist
//     },
//     {
//       path: '/storelist/:id',
//       name: 'storelist',
//       component: storelist
//     },
//     {
//       path: '/storedetail/:id/:activeId',
//       name: 'storedetail',
//       component: storedetail
//     },
//     {
//       path: '/pdfView',
//       name: 'pdfView',
//       component: pdfView
//     },
//   ]
//  });

//  router.beforeEach((to, from, next) => {
//   if (_hmt) {
//     if (to.path) {
//       _hmt.push(['_trackPageview', '/#' + to.fullPath]);
//     }
//   }
// });

// export default router;



// WEBPACK FOOTER //
// ./src/router/index.js